<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@200&display=swap");

.d-none {
  display: none !important;
}
.main {
  padding: 10px 30px;
  display: none;
}
.main_signin {
  padding: 10px 30px;
  display: none;
}

.active {
  display: block !important;
}
.top-div {
  display: flex;
  flex-direction: column;
}

.steps {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0px 10px;
}

.steps .step .circle {
  height: 40px;
  width: 40px;
  background-color: #ccc;
  border-radius: 50%;
}
.steps .step .line {
  width: 22%;
}
.top-div img {
  width: 60px;
  margin-bottom: 10px;
}
.top-div h2 {
  color: #484a4c;
}
.top-div p {
  color: #585e61;
  font-size: 14px;
  font-weight: 700;
}
.input-text {
  margin-bottom: 10px;
  margin-top: 10px;
}
input[type="text"],
input[type="password"],
input[type="email"],
input[type="phone"],
input[type="number"],
input[type="date"] {
  height: 35px;
  border: none;
  background-color: rgba(40, 167, 70, 0.041);
  outline: 0;
  border-bottom: 1px solid #d4dfe4;
  font-size: 16px;
}
input[type="text"]:focus {
  border-color: green;
}
textarea {
  background-color: rgba(40, 167, 70, 0.041);
  height: 100px;
  widows: 100%;
  outline: 0;
  border-bottom: 1px solid #d4dfe4;
}
select {
  height: 35px;
  width: 100%;
  border: none;
  background-color: rgba(40, 167, 70, 0.041);
  outline: 0;
  border-bottom: 1px solid #d4dfe4;
  font-size: 12px;
}
.input-text select option:nth-child(1) {
  display: none !important;
}
.buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
.final_button {
  margin-top: 130px;
}
.buttons button {
  height: 35px;
  width: 100%;
  outline: 0;
  border: 0;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}
.warning {
  border-bottom: 1px solid red !important;
}

.check_box {
  text-align: center;
}
.check_box p {
  font-size: 13px;
  font-weight: 700;
}

.sign_in {
  text-align: center;
  margin: 20px 0;
}
.sign_button {
  margin-top: 70px;
}

.checkmark__circle {
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  stroke-width: 2;
  stroke-miterlimit: 10;
  stroke: #7ac142;
  fill: none;
  animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.checkmark {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: block;
  stroke-width: 2;
  stroke: #fff;
  stroke-miterlimit: 10;
  margin: 10% auto;
  box-shadow: inset 0px 0px 0px #7ac142;
  animation: fill 0.4s ease-in-out 0.4s forwards,
    scale 0.3s ease-in-out 0.9s both;
}

.checkmark__check {
  transform-origin: 50% 50%;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}

.tooltip-button {
  border: 1px solid #d4dfe4;
  border-left: none;
  border-radius: 0px !important;
}

@keyframes stroke {
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes scale {
  0%,
  100% {
    transform: none;
  }
  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
}
@keyframes fill {
  100% {
    box-shadow: inset 0px 0px 0px 30px #7ac142;
  }
}

.steps {
  width: 100%;
  counter-reset: css-counter 0;
  padding: 4px;
}

.steps li {
  list-style: none;
  width: 25%;
  float: left;
  position: relative;
  text-align: center;
  counter-increment: css-counter 1;
}

.steps li:before {
  content: counter(css-counter);

  height: 30px;
  width: 30px;
  background-color: #ccc;
  border-radius: 50%;
  display: block;
  text-align: center;
  margin: 0 auto 10px auto;
  color: #fff;
  line-height: 30px;
}

.steps li:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 3px;
  background-color: blue;
  top: 15px;
  z-index: -1;
}

li:first-child::after {
  display: none;
}

li.li-active::before {
  background-color: green;
}
</style>
<template>
  <div
    class="container my-5 p-3 card shadow-md"
    style="border: 1px solid rgb(40, 167, 69, 0.4)"
  >
    <div class="">
      <div class="">
        <form action="">
          <div class="form">
            <div class="">
              <div class="signup-form s_form">
                <ul class="steps">
                  <li
                    v-for="(page, index) in pages"
                    :key="index"
                    :class="forumnumber >= index - 1 ? 'li-active' : ''"
                  >
                    Step {{ index }}
                  </li>
                </ul>

                <div
                  class="main"
                  v-for="i in nb + 1"
                  :key="i"
                  :class="forumnumber >= i - 1 ? 'active' : ''"
                >
                  <div :style="i < nb + 1 ? 'display: block' : 'display: none'">
                    <h4>Title step {{ i }}</h4>
                    <div class="top-div">
                      <div class="input-text">
                        <label for="name" class="m-0">First name</label> <br />
                        <div class="input-group">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Your first name"
                            id="user_name"
                            require
                            name="name"
                            aria-label="Your first name"
                            aria-describedby="basic-addon2"
                          />
                          <div class="input-group-append" style="position: relative; z-index: 0;">
                            <button
                              type="button"
                              class="btn btn-outline-info border-0"
                              data-toggle="tooltip"
                              data-placement="right"
                              title="Tooltip on right"
                            >
                              <i
                                class="fas fa-info-circle"
                                style="font-size: 20px"
                              ></i>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="input-text">
                        <label for="pname" class="m-0">Second name</label>
                        <br />
                        <div class="input-group">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Your second name"
                            id="pname"
                            require
                            name="name"
                            aria-label="Your first name"
                            aria-describedby="basic-addon2"
                          />
                          <div class="input-group-append">
                            <button
                              type="button"
                              class="btn btn-outline-info border-0"
                              data-toggle="tooltip"
                              data-placement="right"
                              title="Tooltip on right"
                            >
                              <i
                                class="fas fa-info-circle"
                                style="font-size: 20px"
                              ></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="input-text">
                        <label for="phone" class="m-0">Number</label> <br />
                        <div class="input-group">
                          <input
                            type="phone"
                            class="form-control"
                            placeholder="Your number"
                            id="phone"
                            require
                            name="phone"
                            aria-label="Your number"
                            aria-describedby="basic-addon2"
                          />
                          <div class="input-group-append">
                            <button
                              type="button"
                              class="btn btn-outline-info border-0"
                              data-toggle="tooltip"
                              data-placement="right"
                              title="Tooltip on right"
                            >
                              <i
                                class="fas fa-info-circle"
                                style="font-size: 20px"
                              ></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="input-text">
                        <label for="email" class="m-0">Email</label> <br />
                        <div class="input-group">
                          <input
                            type="email"
                            class="form-control"
                            placeholder="Your email"
                            id="email"
                            require
                            name="email"
                            aria-label="Your email"
                            aria-describedby="basic-addon2"
                          />
                          <div class="input-group-append">
                            <button
                              type="button"
                              class="btn btn-outline-info border-0"
                              data-toggle="tooltip"
                              data-placement="right"
                              title="Tooltip on right"
                            >
                              <i
                                class="fas fa-info-circle"
                                style="font-size: 20px"
                              ></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="input-text">
                        <label for="date" class="m-0">Date</label> <br />
                        <div class="input-group">
                          <input
                            type="date"
                            class="form-control"
                            placeholder="Date"
                            id="date"
                            require
                            name="date"
                          />
                          <div class="input-group-append">
                            <button
                              type="button"
                              class="btn btn-outline-info border-0"
                              data-toggle="tooltip"
                              data-placement="right"
                              title="Tooltip on right"
                            >
                              <i
                                class="fas fa-info-circle"
                                style="font-size: 20px"
                              ></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="input-text">
                        <label for="date" class="m-0">Radio</label> <br />
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="inlineRadioOptions"
                            id="inlineRadio1"
                            value="option1"
                          />
                          <label class="form-check-label" for="inlineRadio1"
                            >Radio 1</label
                          >
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="inlineRadioOptions"
                            id="inlineRadio2"
                            value="option2"
                          />
                          <label class="form-check-label" for="inlineRadio2"
                            >Radio 2</label
                          >
                        </div>
                        <div class="form-check form-check-inline">
                          <button
                            type="button"
                            class="btn btn-outline-info border-0"
                            data-toggle="tooltip"
                            data-placement="right"
                            title="Tooltip on right"
                          >
                            <i
                              class="fas fa-info-circle"
                              style="font-size: 20px"
                            ></i>
                          </button>
                        </div>
                      </div>
                      <div class="input-text">
                        <label for="date" class="m-0">Checkbox</label> <br />
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="inlineCheckbox1"
                            value="option1"
                          />
                          <label class="form-check-label" for="inlineCheckbox1"
                            >1</label
                          >
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="inlineCheckbox2"
                            value="option2"
                          />
                          <label class="form-check-label" for="inlineCheckbox2"
                            >2</label
                          >
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="inlineCheckbox3"
                            value="option3"
                          />
                          <label class="form-check-label" for="inlineCheckbox3"
                            >3</label
                          >
                        </div>
                        <div class="form-check form-check-inline">
                          <button
                            type="button"
                            class="btn btn-outline-info border-0"
                            data-toggle="tooltip"
                            data-placement="right"
                            title="Tooltip on right"
                          >
                            <i
                              class="fas fa-info-circle"
                              style="font-size: 20px"
                            ></i>
                          </button>
                        </div>
                      </div>
                      <div class="input-text">
                        <label for="textarea" class="m-0">Textarea</label><br />
                        <div class="input-group">
                          <textarea
                            require
                            class="form-control"
                            aria-label="With textarea"
                          ></textarea>
                          <div class="input-group-prepend">
                            <button
                              type="button"
                              class="btn btn-outline-info border-0"
                              data-toggle="tooltip"
                              data-placement="right"
                              title="Tooltip on right"
                            >
                              <i
                                class="fas fa-info-circle"
                                style="font-size: 20px"
                              ></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="input-text">
                        <label for="name" class="m-0">Select</label>
                        <div class="input-group mb-3">
                          <select class="custom-select" id="inputGroupSelect02" require>
                            <option selected>Choose...</option>
                            <option value="Valeur1">Valeur 1</option>
                            <option value="Valeur2">Valeur 2</option>
                            <option value="Valeur3">Valeur 3</option>
                            <option value="Valeur4">Valeur 4</option>
                          </select>
                          <div class="input-group-append">
                            <button
                              type="button"
                              class="btn btn-outline-info border-0"
                              data-toggle="tooltip"
                              data-placement="right"
                              title="Tooltip on right"
                            >
                              <i
                                class="fas fa-info-circle"
                                style="font-size: 20px"
                              ></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="buttons">
                      <button
                        type="button"
                        class="previous_button bg-outline-secondary"
                        :style="i > 1 ? 'display: block' : 'display: none'"
                      >
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                        Previous
                      </button>
                      <button
                        type="button"
                        class="next_button bg-success text-light"
                        :style="i == nb ? 'display: none' : 'display: block'"
                      >
                        Next
                        <i class="fa fa-arrow-right" aria-hidden="true"></i>
                      </button>
                      <button
                        type="button"
                        class="next_button bg-success text-light"
                        id="val"
                        :style="i == nb ? 'display: block' : 'display: none'"
                      >
                        Save
                        <i class="fa fa-check-circle" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                  <div
                    class="buttons"
                    :style="i == nb + 1 ? 'display: block' : 'display: none'"
                  >
                    <div class="top-div">
                      <h2>Finish</h2>
                      <p>Log in to continue</p>
                    </div>
                    <svg
                      class="checkmark"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 52 52"
                    >
                      <circle
                        class="checkmark__circle"
                        cx="26"
                        cy="26"
                        r="25"
                        fill="none"
                      />
                      <path
                        class="checkmark__check"
                        fill="none"
                        d="M14.1 27.2l7.1 7.2 16.7-16.8"
                      />
                    </svg>
                    <div class="check_box">
                      <p>
                        Congratulations Mr./Mrs
                        <span id="shown_name"></span> you have successfully
                        registered.
                      </p>
                    </div>
                    <button
                      type="submit"
                      class="next_button bg-success text-light"
                    >
                      Revenir
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import SecondInput from "./components/SecondInput.vue";
import { urlGenerator } from "../../../Helpers/AxiosHelper";
import Multiselect from "vue-multiselect";
export default {
  components: {
    SecondInput,
    Multiselect,
  },
  props: [
    "pages",
    "custom_field_types",
    "operations",
    "action",
    "originalCustomValues",
  ],

  data() {
    return {
      nxt_btn: [],
      prev_btn: [],
      main_form: [],
      progressbar: [],
      steps: [],
      forumnumber: 0,
      validate_inputs: [],
      s_form: [],
      nb: 3,
      val: [],

      urlGenerator,
      preloader: false,
      currentTab: 0,
      field_values: [],
      operations_values: [],
      operations_index: [],
      field_index: [],
      page_index: [],
      form_title: "",
      customValues: [],
    };
  },
  created() {
    console.log(this.pages);
    this.form_title = this.pages[0].formname;
    this.pages.forEach((page, page_index) => {
      let data = [];
      page.custom_values.sort(this.compare);
      page.custom_values.forEach((custom_value, index) => {
        if (custom_value.choices == null || custom_value.choices == "") {
          if (custom_value.value == null || custom_value.value == "") {
            data.push({ value: custom_value.default_value });
          } else {
            if (
              typeof custom_value.value == "number" ||
              typeof custom_value.value == "string"
            ) {
              data.push({ value: custom_value.value });
            } else {
              data.push({ value: "" });
            }
          }
        } else {
          if (custom_value.choices.split(";").includes(custom_value.value)) {
            if (
              this.custom_value_type(custom_value.custom_field_type_id) ==
                "checkbox" ||
              this.custom_value_type(custom_value.custom_field_type_id) ==
                "multi-select"
            ) {
              if (custom_value.choices.includes("#single:")) {
                data.push({
                  value: custom_value.value,
                });
              } else {
                data.push({ value: custom_value.value.split(";") });
              }
            } else {
              data.push({ value: custom_value.value });
            }
          } else {
            if (
              this.custom_value_type(custom_value.custom_field_type_id) ==
                "checkbox" ||
              this.custom_value_type(custom_value.custom_field_type_id) ==
                "multi-select"
            ) {
              if (custom_value.choices.includes("#single:")) {
                data.push({
                  value: custom_value.default_value,
                });

                custom_value.value = custom_value.default_value;
              } else {
                if (custom_value.default_value != null) {
                  data.push({ value: custom_value.default_value.split(";") });
                  custom_value.value = custom_value.default_value.split(";");
                } else {
                  data.push({ value: "" });
                  custom_value.value = "";
                }
              }
            } else {
              if (custom_value.default_value != null) {
                data.push({ value: custom_value.default_value });
                custom_value.value = custom_value.default_value;
              } else {
                data.push({ value: "" });
                custom_value.value = "";
              }
            }
          }
        }
        this.field_index[custom_value.id] = index;
        this.page_index[custom_value.id] = page_index;
      });
      this.field_values.push(data);
    });

    this.operations.forEach((operation) => {
      this.operations_values[operation.result] = {
        operand1: operation.operand1,
        operand2: operation.operand2,
        operator: operation.operator,
        type: operation.type,
        value: operation.type,
      };
      this.operations_index.push(operation.result);
    });
  },
  mounted() {
    this.nxt_btn = document.querySelectorAll(".next_button");
    this.prev_btn = document.querySelectorAll(".previous_button");
    this.main_form = document.querySelectorAll(".main");
    this.progressbar = document.querySelectorAll(".steps li");
    this.steps = document.querySelector(".steps");
    this.validate_inputs = [...document.querySelectorAll(".main.active input"), ...document.querySelectorAll(".main.active textarea"), ...document.querySelectorAll(".main.active select")]
    this.s_form = document.querySelectorAll(".s_form");
    this.val = document.getElementById("val");
    console.log(this.val);

    this.nxt_btn.forEach((butn) => {
      butn.addEventListener("click", this.onNext);
    }),
      this.prev_btn.forEach((prev_button) => {
        prev_button.addEventListener("click", this.onBack);
      });
    document.addEventListener("click", this.valeurs);
  },
  methods: {
    compare(a, b) {
      if (a.custom_field_type_id < b.custom_field_type_id) {
        return -1;
      }
      if (a.custom_field_type_id > b.custom_field_type_id) {
        return 1;
      }
      return 0;
    },

    reoderCustomValues(customValues) {},
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },
    createBase64(event, custom) {
      let file = event.target.files ? event.target.files[0] : null;
      if (file) {
        const reader = new FileReader();
        reader.onload = (event) => {
          custom.value = event.target.result;
          custom.file_name = file.name;
        };
        reader.readAsDataURL(file);
      }
    },
    setCustomValue(value, custom) {
      if (
        this.custom_value_type(custom.custom_field_type_id) == "multi-select" ||
        this.custom_value_type(custom.custom_field_type_id) == "checkbox"
      ) {
        if (custom.choices.includes("#single:")) {
          custom.value = value;
        } else {
          custom.value = value.join(";");
        }
      } else {
        custom.value = value;
      }
    },
    getFieldOperationValue(operand1, operand2, operator, type) {
      let op2;
      let op1;

      if (this.field_index[operand1] !== undefined) {
        op1 =
          this.field_values[this.page_index[operand1]][
            this.field_index[operand1]
          ].value;
      } else {
        op1 = operand1;
      }

      if (this.field_index[operand2] !== undefined) {
        op2 =
          this.field_values[this.page_index[operand2]][
            this.field_index[operand2]
          ].value;
      } else {
        op2 = operand2;
      }

      return this.makeOperation(type, operator, op1, op2);
    },
    makeOperation(type, operator, op1, op2) {
      if (type == "concat") {
        return op1 + " " + op2;
      } else if (type == "math") {
        op1 = parseInt(op1);
        op2 = parseInt(op2);

        if (isNaN(op1)) {
          op1 = 0;
        }
        if (isNaN(op2)) {
          op2 = 0;
        }

        if (operator == "addition") {
          return op1 + op2;
        } else if (operator == "substraction") {
          return op1 - op2;
        } else if (operator == "division") {
          return op1 / op2;
        } else if (operator == "multiplication") {
          return op1 * op2;
        }
      }
    },
    next(tab, n) {
      var x = document.getElementsByClassName("tab");
      x[tab].style.display = "none";
      // Increase or decrease the current tab by 1:
      this.currentTab = tab + n;

      // Otherwise, display the correct tab:
      this.showTab(this.currentTab);
    },

    custom_value_type(id) {
      let type = this.custom_field_types.filter(
        (el) => parseInt(el.id) === parseInt(id)
      );
      return type[0].name;
    },

    getOperationName(op) {
      let result;
      if (this.action == "test") {
        result = this.originalCustomValues.find(({ id }) => id === op);
      } else {
        result = this.originalCustomValues.customValues.find(
          ({ id }) => id === op
        );
      }
      return result.name;
    },
    getOperationValue(operation) {
      let op1 = this.findOperationValue(operation.operand1);
      let op2 = this.findOperationValue(operation.operand2);

      return this.makeOperation(operation.type, operation.operator, op1, op2);
    },
    findOperationValue(op) {
      let value;
      const result = this.customValues.find(({ id }) => id === op);
      if (result == null) {
        const result1 = this.originalCustomValues.customValues.find(
          ({ id }) => id === op
        );
        if (result1 == null) {
          value = op;
        } else {
          value = result1.value;
        }
      } else {
        value = result.value;
      }
      return value;
    },
    onNext() {
      if (!this.validateform()) {
        return false;
      }
      this.forumnumber++;
      this.progress("color");
      this.update_form();
    },
    onBack() {
      this.forumnumber--;
      this.progress("nocolor");
      this.update_form();
    },
    valeurs() {
      let i;
      for (i = 1; i < this.nb; i++) {
        if (i == this.nb) {
          document.getElementsById("val").style.display = "none";
        }
        console.log(i, this.nb);
      }
    },

    progress(state) {
      if (state == "color") {
        this.progressbar[this.forumnumber].classList.add("li-active");
      } else {
        this.progressbar[this.forumnumber + 1].classList.remove("li-active");
      }
    },
    update_form() {
      this.main_form.forEach(function (main) {
        main.classList.remove("active");
      });
      this.main_form[this.forumnumber].classList.add("active");
      this.validate_inputs = document.querySelectorAll(".main.active input");
    },

    validateform() {
      let validate = true;
      console.log(this.validate_inputs);
      this.validate_inputs.forEach(function (input_valid) {
        input_valid.classList.remove("warning");
        if (input_valid.hasAttribute("require")) {
          if (input_valid.value.length == 0) {
            validate = false;
            input_valid.classList.add("warning");
          }
        }
      });
      return validate;
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.multiselect__tags {
  background-color: transparent !important;
  min-height: 42px !important;
  padding: 12px 40px 0 5px !important;
  outline: 0 !important;
  border: 1px solid #d4dfe4 !important;
  border-right: none !important;
  border-radius: 0px !important;
}
.multiselect__option--selected,
.multiselect__option--highlight,
.multiselect__option--highlight:hover,
.multiselect__content .multiselect__option:hover {
  background-color: blue !important;
  color: white !important;
}
.multiselect__select {
  padding: 30px 8px;
}
</style>
